<template>
  <div class="enable-call-taker-mode">
    <div class="enable-call-taker-mode--content mb-3">
      <PositionPicker @selected="selectPosition" />
    </div>
    <div class="enable-call-taker-mode--actions d-flex flex-row-reverse align-items-center bg-light">
      <b-button
        pill
        variant="info"
        :disabled="!position || enabling"
        @click="assignPositionToUser"
      >
        <template v-if="!enabling">Enable</template>
        <i v-else class="fa fa-spinner fa-spin"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/events/eventBus";
import PositionPicker from "@/components/conversations/PositionPicker";

export default {
  name: "EnableCallTakerMode",
  components: {
    PositionPicker,
  },
  data() {
    return {
      enabling: false,
      position: null,
    };
  },
  computed: {
    ...mapGetters("user", ["currentUser"])
  },
  methods: {
    ...mapActions("user", ["updateCallTakerMode"]),
    selectPosition(position) {
      this.position = position;
    },
    async assignPositionToUser() {
      try {
        this.enabling = true;
        await this.$ConveyApi.agenciesApi.assignPositionToUser({
          userId: this.currentUser.user_id,
          positionId: this.position.position_id,
        });
        this.updateCallTakerMode(this.position);
        this.$toastr(
          "success",
          `Enabled Call Taker Mode.<br>Call position <strong style="font-size: 1.2em">${this.position.sip_id}</strong> <span style="font-size: 0.85em;">${this.position.position_name ? this.position.position_name : ''}</span> is assigned to you.`
        );
      } catch(err) {
        console.log("[EnableCallTakerMode:assignPositionToUser] ERROR: ", err);
        this.$toastr("error", `Error encountered assigning call position to you.`);
      } finally {
        this.enabling = false;
        EventBus.$emit("close-modal");
      }
    },
  },
};
</script>

<style lang="scss">
.enable-call-taker-mode {
  &--actions {
    margin-left: -1rem;
    margin-right: -1rem;
    margin-bottom: -1rem;
    padding: 1rem;
    border-radius: 0 0 1rem 1rem;
  }
}
</style>